import { vioAPI } from '@/api/index'

/**
 * 获取token
 * @param ops
 * @returns {*}
 */
function getToken (opts) {
  return vioAPI.p_getCode_get(opts)
}

/**
 * 获取用户举报的违法列表
 * @param opts
 * @returns {*}
 */
function getVioReportList (opts) {
  return vioAPI.p_getVioList_get(opts)
}

/**
 * 获取用户信息
 * @param opts
 * @returns {*}
 */
 function getuserInfo (opts) {
  return vioAPI.userInfo(opts)
}
/**
 * 获取违法类型列表
 * @param opts
 * @returns {*}
 */
function getWflxList (opts) {
  return vioAPI.commonDict(opts)
}

/**
 * 获取图片
 * @param opts
 * @returns {*}
 */
function upload_post (opts) {
  return vioAPI.p_upload_post(opts)
}
/**
 * 保存奖励银行信息
 * @param opts
 * @returns {*}
 */
function saveRewardBankInfo (opts) {
  return vioAPI.p_reward_saveBankInfo_post(opts)
}
/**
 * 获取图片url
 * @param opts
 * @returns {*}
 */
 function uploadurl_post (opts) {
  return vioAPI.uploadurl_post(opts)
}
/**
 * 获取图片url
 * @param opts
 * @returns {*}
 */
 function changeHeicToJpg_post (opts) {
  return vioAPI.p_changeHeicToJpg_post(opts)
}
/**
 * 提交违法举报信息
 * @param opts
 * @returns {*}
 */
function commitVioReport (opts) {
  return vioAPI.p_report_post(opts)
}

/**
 * 材料补充上传
 * @param opts
 * @returns {*}
 */
 function supplementPost (opts) {
  return vioAPI.supplement_post(opts)
}

/**
 * 获取告知
 * @param opts
 * @returns {*}
 */
function getNotice (opts) {
  return vioAPI.p_getNotice_get(opts)
}
/**
 * 获取手机端表单配置
 * @param opts
 * @returns {*}
 */
function getAppConfig (opts) {
  return vioAPI.p_getAppConfig_get(opts)
}
/**
 * 地址预校验
 * @param opts
 * @returns {*}
 */
 function getAddressCheck (opts) {
  return vioAPI.addressCheck(opts)
}
/**
 * OSS直传：获取上传签名（/ossFile/policy）
 * @param opts
 * @returns {*}
 */
function getOssPolicy (opts) {
  return vioAPI.p_oss_policy_post(opts)
}
/**
 * OSS直传：完成核验（/ossFile/complete）
 * @param opts
 * @returns {*}
 */
function completeOssUpload (opts) {
  return vioAPI.p_oss_complete_post(opts)
}

export {
  getAddressCheck,
  getuserInfo,
  getToken,
  getVioReportList,
  getWflxList,
  upload_post,
  saveRewardBankInfo,
  uploadurl_post,
  supplementPost,
  commitVioReport,
  getNotice,
  getAppConfig,
  changeHeicToJpg_post,
  getOssPolicy,
  completeOssUpload
}



// WEBPACK FOOTER //
// ./src/service/vioReport/index.js